export default __webpack_public_path__ + "static/media/workout.ab595814.png";